<template lang="pug">
  v-menu(offset-x v-model="display" :position-x="x",:position-y="y")
    v-list(dense)
      template(v-for="icon in CARD_ICONS")
        v-list-tile(@click="setMark(icon.value)")
          v-list-tile-action
            v-icon() {{ icon.icon }}
          v-list-tile-content {{ icon.label }}

      v-divider
      v-list-tile(@click="setMark(CLEAR_ICON.value)")
        v-list-tile-action
          v-icon() {{ CLEAR_ICON.icon_alt }}
        v-list-tile-content {{ CLEAR_ICON.label }}
</template>

<script>
import { useCardMarkType } from "@/composables/dispatch/useCardMarkType";

export default {
  props: {
    isDynamic: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  setup() {
    const { CARD_MARKS, CARD_ICONS, CLEAR_ICON } = useCardMarkType();

    return {
      ...CARD_MARKS,
      CARD_ICONS,
      CLEAR_ICON
    };
  },
  data() {
    return {
      display: false,
      x: 0,
      y: 0,
      item: {}
    };
  },
  computed: {
    cardMarkAction: {
      get() {
        if (this.isDynamic) {
          return "dynamic/saveCardMark";
        } else {
          return "dispatch/saveCardMark";
        }
      }
    }
  },
  methods: {
    open(data) {
      this.item = data.item;
      // TODO tickイベント実装？（既に開いていると別のが開かない。二回押下で開くので）
      this.display = false;
      this.x = data.event.clientX;
      this.y = data.event.clientY;
      this.display = true;
    },
    setMark(markCd) {
      let req = {
        orderId: this.item.orderId,
        orderType: this.item.orderType,
        markType: markCd
      };

      this.$store
        .dispatch(this.cardMarkAction, req)
        .then(() => {
          this.item.cardMark = markCd;
        })
        .catch(reason => {
          this.$emit("error", reason.message);
        });
    }
  }
};
</script>

<style lang="stylus"></style>
